import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-ask-dialog',
  templateUrl: './ask-dialog.component.html',
  styleUrls: ['./ask-dialog.component.scss'],
})
export class AskDialogComponent implements OnInit {
  public dialogYesNo: any;

  constructor(
    public dialogRef: MatDialogRef<AskDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.dialogYesNo = data;
  }

  ngOnInit(): void { }

  closeDialog(isYes: boolean) {
    this.dialogRef.close(isYes);
  }

  applyStrings(s: string, replace: string[]) {
    for (let i = 0; i < replace.length; i++) {
      s = s.replace(/%s/, replace[i])
    }
    return s;
  }
}
